export enum FactoryTypes {
  STEP = "step",
  NUMBERED_STEP = "numberedStep",
  GUIDE_INTRO = "guideIntro",
  TIPBOX = "tipBox",
  DECISION_STEP = "decisionStep",
  ACTIVATION_FORM = "activationForm",
  POPUP = "popup",
  EXPERT_HELP = "expertHelp",
  IMAGE = "image",
  IMAGE_CAROUSEL = "imageCarousel",
  WIZARD = "wizard",
  SURVEY_STEP = "surveyStep",
  // TODO: Instead of hard coding different styles like this
  // let's rediscuss as a team how to create a smart nested
  // step system
  SUB_STEP = "subStep",
  DROPDOWN_STEP = "dropdownStep",
  WIZARD_STEP_LINK = "wizardStepLink",
  WIZARD_BUTTON = "wizardButton",
}
